import { Flex } from "@fluentui/react-northstar";
import React from "react";
import { useTranslation } from "react-i18next";
import Illustration from "../../../components/shared/Illustration";
import { Container, ErrorDescription, ErrorTitle, Title } from "../style";
import { I18N_NS_LEAVE } from "../../leave/constants";

const ValidateSuccess = () => {
    const { t } = useTranslation(I18N_NS_LEAVE);
    return (
        <Container
            column
            gap="gap.large"
            styles={{ zIndex: 3, height: "447px!important" }}
        >
            <Flex>
                <Title
                    content={t("extern_manager_validation_leave.success.title")}
                />
            </Flex>
            <Flex column hAlign="center" gap="gap.medium">
                <Illustration filename={"Thumb-up.svg"} width="200px" />
                <ErrorTitle
                    content={t(
                        "extern_manager_validation_leave.success.response.sent"
                    )}
                />
                <ErrorDescription
                    content={t(
                        "extern_manager_validation_leave.success.response.description"
                    )}
                />
            </Flex>
        </Container>
    );
};

export default ValidateSuccess;
